var render = function render(){var _vm=this,_c=_vm._self._c;return _c('search-component',{attrs:{"placeholder":"Filtrar por categoria","prop":{text: 'Categoria', key: 'category_id'},"model_name":"category","id":"search-category","props_to_filter":['name']},on:{"setSelected":_vm.setSelected,"clearSelected":_vm.clearSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }